module.exports = __webpack_public_path__ + "img/150-16f03c.png";